import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function openCenterFinalCosts(id: number) {
  return restApiClient.url(constructApiUrl(API.centers.openFinalCosts.url, { id })).post()
}
